/* A small, tab-local browsing shelf. No history is sent to a service. */
(() => {
  const KEY = 'tandoori-recent-books-v1';
  function cleanHistory(value, origin) {
    if (!Array.isArray(value)) return [];
    const result = [], seen = new Set();
    for (const item of value.slice(0, 24)) {
      if (!item || !/^\d+$/.test(String(item.id)) || typeof item.title !== 'string' || !item.title.trim() || seen.has(String(item.id))) continue;
      try {
        const url = new URL(item.url, origin);
        if (url.origin !== origin || !/^\/(?:[a-z]{2}(?:-[a-zA-Z]{2})?\/)?products\/[^/]+$/.test(url.pathname)) continue;
        let image = '';
        try {
          const cover = new URL(String(item.image).startsWith('//') ? 'https:' + item.image : item.image, origin);
          if (item.image && (cover.origin === origin || (cover.protocol === 'https:' && ['cdn.shopify.com','wi9rgr-id.myshopify.com'].includes(cover.hostname)))) image = cover.href;
        } catch { /* Keep books with missing covers. */ }
        seen.add(String(item.id));
        result.push({id:String(item.id),title:item.title.slice(0,300),url:url.pathname,image});
        if (result.length === 12) break;
      } catch { /* Ignore invalid stored product links. */ }
    }
    return result;
  }
  function remember(history, current, origin) { return cleanHistory(current ? [current,...history] : history, origin); }
  if (typeof module !== 'undefined' && module.exports) { module.exports={cleanHistory,remember};return; }
  if (customElements.get('tandoori-recent-books')) return;
  customElements.define('tandoori-recent-books',class extends HTMLElement {
    connectedCallback() {
      if (this.ready || this.dataset.designMode === 'true') return;
      this.ready=true;
      let books=[];
      try { books=cleanHistory(JSON.parse(sessionStorage.getItem(KEY)||'[]'),location.origin); } catch { /* Disabled storage leaves this shelf hidden. */ }
      const current=cleanHistory([this.dataset],location.origin)[0];
      books=remember(books,current,location.origin);
      try { sessionStorage.setItem(KEY,JSON.stringify(books)); } catch { /* Storage is optional. */ }
      const visible=books.filter(book=>book.id!==current?.id).slice(0,6);
      const list=this.querySelector('[data-recent-items]');list.replaceChildren();
      for(const book of visible){
        const card=this.querySelector('template').content.cloneNode(true);
        card.querySelector('a').href=book.url;
        card.querySelector('[data-recent-title]').textContent=book.title;
        const image=card.querySelector('img');
        if(book.image){image.src=book.image;image.addEventListener('error',()=>image.remove(),{once:true});}else image.remove();
        Object.assign(card.querySelector('[data-save-book]').dataset,book);
        list.append(card);
      }
      this.querySelector('[data-recent-shelf]').hidden=!visible.length;
      this.clear=()=>{
        try { sessionStorage.removeItem(KEY); } catch { /* Still clear the visible shelf. */ }
        list.replaceChildren();
        this.querySelector('[data-recent-shelf]').hidden=true;
        const status=this.querySelector('[data-recent-status]');status.textContent=this.dataset.cleared;
        status.tabIndex=-1;status.focus({preventScroll:true});
      };
      this.querySelector('[data-recent-clear]').addEventListener('click',this.clear);
    }
    disconnectedCallback(){this.querySelector('[data-recent-clear]')?.removeEventListener('click',this.clear);this.ready=false;}
  });
})();
